import React, { memo } from 'react'

import ReceiveExternalRewards from './ReceiveExternalRewards'
import customConfig from 'customConfig'

const ReceiveExternalRewardsInit = ({
  provider,
  reward,
  onSubmit,
  onCancel,
  tokenProfile: { symbol, offramp },
  cryptoExchanges,
  rewardsProfile: { loading },
  t
}) => {
  const name = provider?.name
  const isCrypto = provider?.isCrypto
  return (
    <ReceiveExternalRewards
      provider={provider}
      reward={reward}
      title={t('exchange.exchange-your-points', { symbol })}
      description={
        isCrypto
          ? t('exchange.get-crypto-desc', { name })
          : t(customConfig.receiveFollowingRewardsLabel, {
              label: t('common.get'),
              name
            })
      }
      submitLabel={t('common.confirm')}
      onSubmit={onSubmit}
      onCancel={onCancel}
      offramp={offramp}
      cryptoExchanges={cryptoExchanges}
      disabledSubmit={loading}
      t={t}
    />
  )
}

export default memo(ReceiveExternalRewardsInit)
